import ProfileStore from '../../store/profiles';
import PoliciesProfileUIStateStore from '../../store/policies-profile-ui';
import { snapshot } from 'valtio';
import PoliciesStore from '../../store/policies';

export const editNewProfile = (field: string, newValue: boolean | string) => {
  const profileStore = snapshot(ProfileStore);
  const oldValue = profileStore.newProfile;
  ProfileStore.newProfile = {
    ...oldValue,
    responseErorMessage: '',
    payload: {
      ...oldValue.payload,
      [field]: newValue,
    },
  };
};

export const switchBetweenActiveProfiles = (active: boolean) => {
  const profileStore = snapshot(ProfileStore);
  if (profileStore.profileInContext !== undefined) {
    const oldActiveValue = profileStore.profiles.find(
      p => p.profileId === profileStore.profileInContext?.profileId,
    )?.active;
    ProfileStore.profileInContext = {
      ...profileStore.profileInContext,
      active,
    };
    PoliciesProfileUIStateStore.disableSavePoliciesButton =
      oldActiveValue === active;
  }
};

export const updateProfileTotalEnabledPolicies = (
  policyId: string,
  checked: boolean,
) => {
  const { enabledPolicies, policiesPerCategoriesInfo } = snapshot(ProfileStore);
  const { policies } = snapshot(PoliciesStore);
  const { catId } = policies[policyId];
  ProfileStore.policiesPerCategoriesInfo = policiesPerCategoriesInfo.map(
    categoriesInfo => {
      return catId === categoriesInfo.id
        ? {
            ...categoriesInfo,
            enbaledPolicies: checked
              ? categoriesInfo.enbaledPolicies + 1
              : categoriesInfo.enbaledPolicies - 1,
          }
        : categoriesInfo;
    },
  );
  ProfileStore.enabledPolicies = checked
    ? enabledPolicies + 1
    : enabledPolicies - 1;
};
